import React, { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import Grid from "@mui/material/Grid"
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';
import Alert from '@mui/material/Alert';
// import List from '@mui/material/List';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemText from '@mui/material/ListItemText';
// import Checkbox from '@mui/material/Checkbox';
// import CardHeader from '@mui/material/CardHeader';
// import Card from '@mui/material/Card';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import Box from "@mui/material/Box";
// import SearchField from "react-search-field";
import EditIcon from "@mui/icons-material/Edit";
import Autocomplete from '@mui/material/Autocomplete';

const options = [
  { id: 1, name: "Email", value: "email" },
];

export default function AssignUsersEdit(props) {
  const { labType, InstanceID, count, is_userassign } = props;
  const [formFieldsToAdd, setformFieldsToAdd] = React.useState([]);

  const [state, setState] = React.useState({
    email: "",
    // username: "",
    validationError: "",
    errorMessage: "",
  });

  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    setEditSuccessOpen(false);
    // window.location.reload(false);
  };

  const handleAddForm = () => {
    setOpen(true);
    let collectType = [];
    for (var i = 0; i < count; i++) {
      const data = {
        id: i,
        email: "",
        // username: ""
      };
      collectType.push(data)
    }
    setformFieldsToAdd(collectType);
  };

  const [value, setValue] = React.useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const [editSuccessOpen, setEditSuccessOpen] = useState(false);
  const handleEditSuccessClose = () => {
    setEditSuccessOpen(false);
    window.location.reload(false);
  };

  const [traineeuserlist, setTraineeuserlist] = React.useState([]);
  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/user_management/traineeuserlistView/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((resp) => setTraineeuserlist(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const [assignedUserList, setAssignedUserList] = React.useState([]);
  const [modifiedAssignedUserList, setModifiedAssignedUserList] = React.useState([]);
  useEffect(() => {
    let labid = InstanceID;
    let labtype = labType;
    fetch(`${process.env.REACT_APP_API_URL}/api/getuserandassignlab/${labid}/${labtype}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data) {
          setAssignedUserList(data);
          setModifiedAssignedUserList(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [InstanceID, labType]);

  const handleChange2 = (e, index) => {
    const { name, value } = e.target;
    const [id, email] = value.split(',');
    const selectedId = id.trim();
    const selectedEmail = email.trim();
    const list = JSON.parse(JSON.stringify(modifiedAssignedUserList));
    list[index][name] = selectedEmail;
    list[index]['user_id'] = parseInt(selectedId);
    setModifiedAssignedUserList(list);
  };

  const handleSubmitClick = (e) => {
    e.preventDefault();
    let hasDuplicates = false;
    const data = {
      lab_id: InstanceID,
      lab_type: labType,
      details: modifiedAssignedUserList
    };

    console.log("data-testing", JSON.stringify(data));
    for (let i = 0; i < modifiedAssignedUserList.length; i++) {
      for (let j = i + 1; j < modifiedAssignedUserList.length; j++) {
        if (modifiedAssignedUserList[i]['email'] === "Not Assigned" && modifiedAssignedUserList[j]['email'] === "Not Assigned"){
          hasDuplicates = false;
        }
        else if (modifiedAssignedUserList[i]['email'] === modifiedAssignedUserList[j]['email']) {
          hasDuplicates = true;
          break;
        }
      }
      if (hasDuplicates) {

        setDialogOpen(true);
        break;
      }
    }

    if (!hasDuplicates) {

      fetch(`${process.env.REACT_APP_API_URL}/api/updateuserandassignlab/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          console.error(data);
          if (data.code === 500) {
            setState({ validationError: data.message })
          } else {
            // handleClose();
            setEditSuccessOpen(true);
            setOpen(false);
          }
        })
        .catch((error) => {
          console.error(error);
          setState({ errorMessage: "Something Went Wrong" });
        });
    }
  };

  return (
    <div>
      <Tooltip title={is_userassign === 'no' ? "No users assigned" : "Edit Assigned Users"} arrow>
        <span>
          <IconButton
            aria-label="edit"
            onClick={() => handleAddForm()}
            disabled={is_userassign === 'no'}
          >
            <EditIcon style={{ color: is_userassign === 'no' ? "" : "#009688" }} />
          </IconButton>
        </span>
      </Tooltip>
      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogTitle>Notification !</DialogTitle>
        <DialogContent>
          <p>Same Email-Id's selected. Please choose a different email address.</p>
        </DialogContent>
        <DialogActions>
          <Tooltip title="OK" arrow>
            <Button onClick={handleDialogClose} color="primary" autoFocus sx={{ borderRadius: '50px', px: 3, py: 1 }}>
              Ok
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog open={editSuccessOpen} onClose={handleEditSuccessClose}>
        <DialogTitle>Notification !</DialogTitle>
        <DialogContent>
          <p>Assigned Trainees has been updated successfully.</p>
        </DialogContent>
        <DialogActions>
          <Tooltip title="OK" arrow>
            <Button onClick={handleEditSuccessClose} color="primary" autoFocus sx={{ borderRadius: '50px', px: 3, py: 1 }}>
              Ok
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">ASSIGN USERS</DialogTitle>
        {state.validationError != "" ?
          <DialogContent dividers>
            <Alert severity="error">
              <Typography color="textSecondary" gutterBottom variant="h6">
                {state.validationError}
              </Typography>
            </Alert>
          </DialogContent>
          : ""}
        <DialogContent dividers>
          {assignedUserList.map((e, index) => {
            let trid = index + 1
            return (
              <div id={index + 1} key={index}>
                <Typography color="textPrimary" gutterBottom variant="h5">
                  Trainee - {trid}:
                </Typography>
                <Divider />
                <Typography color="textPrimary" gutterBottom variant="body1" style={{ marginTop: "10px" }}>
                  Assigned Email : {assignedUserList[index].email}
                </Typography>
                <Grid container spacing={4} sx={{ pt: 1, mb: 4 }}>
                  <Grid item md={6} xs={12}>
                    <InputLabel>
                      Email&nbsp;<small >required</small>
                      <small style={{ color: "red" }}>*</small>
                    </InputLabel>
                    <Autocomplete
                      fullWidth
                      id="email"
                      options={traineeuserlist}
                      getOptionLabel={(option) => option.email}
                      onChange={(event, value) => handleChange2({ target: { name: 'email', value: `${value?.id},${value?.email}` } }, index)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select the Trainee"
                          InputLabelProps={{ shrink: true }}
                          required
                          sx={{ width: '400px' }}
                          style={{ color: '#ffffff', marginLeft: '20px', marginTop: '10px' }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </div>
            );
          })}
        </DialogContent>
        <DialogActions>
          <Tooltip title="Cancel" arrow>
            <Button onClick={handleClose} variant="contained" color="secondary" sx={{ borderRadius: '50px', px: 3, py: 1 }}>
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Assign" arrow>
            <span>
              <Button variant="contained" type="submit" color="primary" onClick={handleSubmitClick} sx={{ borderRadius: '50px', px: 3, py: 1 }}>
                Assign
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </div>
  );
}

